import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function SEOSchema() {
  const location = useLocation();

  useEffect(() => {
    // Remove existing schema scripts
    const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
    existingSchemas.forEach(script => script.remove());

    // Add schemas based on current page
    if (location.pathname === '/') {
      addHomePageSchemas();
    }
  }, [location.pathname]);

  const addHomePageSchemas = () => {
    // Local Business Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Readdy Services - Venting & Exhaust Install Repair Company",
      "image": `${SITE_URL}/logo.jpg`,
      "description": "Professional chimney repair, ventilation, and exhaust fan services for residential and commercial properties in New York.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "39 West 29th Street, 6th Floor",
        "addressLocality": "New York",
        "addressRegion": "NY",
        "postalCode": "10001",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 40.7455,
        "longitude": -73.9881
      },
      "telephone": "+1-646-308-1336",
      "email": "nkrservicecalendar@gmail.com",
      "priceRange": "$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        }
      ],
      "url": SITE_URL,
      "areaServed": {
        "@type": "City",
        "name": "New York"
      },
      "serviceType": ["Chimney Repair", "Ventilation Repair", "Fireplace Repair", "Exhaust Fan Repair"]
    };

    // Service Schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Chimney and Ventilation Repair",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Readdy Services - Venting & Exhaust Install Repair Company"
      },
      "areaServed": {
        "@type": "City",
        "name": "New York"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Chimney and Ventilation Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Chimney Repair & Exhaust Fan Service",
              "description": "We repair chimney exhaust fans, blocked flues, airflow issues, and damaged venting systems to ensure proper draft and safety."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Rooftop Ventilation Unit Repair",
              "description": "Expert servicing and repair of roof-mounted ventilation and exhaust units for residential and commercial properties."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Fireplace Repair & Restoration",
              "description": "From airflow problems to structural repairs, we restore fireplaces to safe, efficient operation."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Ventilation System Repair",
              "description": "Complete diagnostics and repairs for ventilation units to improve indoor air quality and system performance."
            }
          }
        ]
      }
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Readdy Services - Venting & Exhaust Install Repair Company",
      "url": SITE_URL,
      "logo": `${SITE_URL}/logo.jpg`,
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-646-308-1336",
        "contactType": "customer service",
        "email": "nkrservicecalendar@gmail.com",
        "areaServed": "US",
        "availableLanguage": "English"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "39 West 29th Street, 6th Floor",
        "addressLocality": "New York",
        "addressRegion": "NY",
        "postalCode": "10001",
        "addressCountry": "US"
      },
      "sameAs": []
    };

    // WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Readdy Services - Venting & Exhaust Install Repair Company",
      "url": SITE_URL,
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${SITE_URL}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    };

    // Add all schemas to head
    [localBusinessSchema, serviceSchema, organizationSchema, websiteSchema].forEach(schema => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  };

  return null;
}
